// extracted by mini-css-extract-plugin
export var deleteModal = "_f5-0";